
@if (!edit) {
  <h1 mat-dialog-title>Sprachhandlung erstellen</h1>
}
@if (edit) {
  <h1 mat-dialog-title>Sprachhandlung bearbeiten</h1>
}

<mat-dialog-content class="custom-scrollbar w800">
  <app-folder-usage-hint [entryId]="id" type="VERBAL_ACTION_ENTRY"></app-folder-usage-hint>
  <form [formGroup]="verbalActionFormGroup" class="pad-top8">
    <div class="top-row">
      <mat-form-field appearance="outline" class="w49 marg-right2">
        <mat-label>Name</mat-label>
        <input formControlName="nameCtrl" matInput placeholder="" required>
      </mat-form-field>

      <div (click)="openCategorySelectionDialog()" tabindex="0" class="w49 clickable">
        <mat-form-field appearance="outline" class="w100">
          <mat-label>Thema</mat-label>
          <mat-select formControlName="categoryId" placeholder="">
            @if (selectedCategory) {
              <mat-option [value]="selectedCategory.id">{{ selectedCategory.name }}</mat-option>
            } @else {
              <mat-option [value]="null">&mdash;</mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
    </div>

    <div class="level-row">
      <mat-form-field appearance="outline" class="w50 marg-right2">
        <mat-label>Rezeptiv</mat-label>
        <mat-select formControlName="receptive" placeholder="">
          <mat-option [value]="'NONE'">&mdash;</mat-option>
          @for (option of levelList; track option) {
            <mat-option [value]="option">{{ option }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
      <mat-form-field appearance="outline" class="w50">
        <mat-label>Produktiv</mat-label>
        <mat-select formControlName="productive" placeholder="">
          <mat-option [value]="'NONE'">&mdash;</mat-option>
          @for (option of levelList; track option) {
            <mat-option [value]="option">{{ option }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>

    <button (click)="addExample()" color="primary" mat-raised-button type="button">Beispielsatz hinzufügen</button>
    <ul formArrayName="examples" style="padding: 0;">
      @for (e of examples().controls; track e; let i = $index) {
        <li [formGroupName]="i" style="list-style: none;">
          <mat-form-field appearance="outline" class="w100">
            <mat-label>Beispielsatz {{ i + 1 }}</mat-label>
            <textarea formControlName="example" class="custom-scrollbar" matInput></textarea>
            <button matSuffix mat-icon-button type="button" (click)="removeExample(i)" color="warn">
              <mat-icon>delete</mat-icon>
            </button>
          </mat-form-field>
        </li>
      }
    </ul>
  </form>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-dialog-close mat-raised-button>Abbrechen</button>
  <button (click)="save()"
          [disabled]="verbalActionFormGroup.controls['nameCtrl'].hasError('required') || !selectedCategory"
          color="primary"
          mat-raised-button>Speichern
  </button>
</mat-dialog-actions>
